import { DialogCreateProps } from './dialogProps';
import { Dialog, DialogAction } from './dialogType';

export function buildDialog(props: DialogCreateProps): Dialog {
    return {
        ...props,
        actions: props.actions.map<DialogAction>((action) => ({ ...action, variant: action.variant ?? 'default' }), []),
    };
}
